/* src/app/forms/wizard-configuracao/remotedb-type-service/remotedb-type-service.component.scss */
/*# sourceMappingURL=remotedb-type-service.component.css.map */
